<mibp-dialog #dialog [buttons]="dialogButtons" [titleResourceStringKey]="dialogTitle" (buttonClick)="dialogClick($event)"  size = "narrow"  [id]="'system-message-dialog'">
  <div class="dialog-container">
    <div class="row">
      @if (currentMessage?.imageUserFileId) {
        <div class="messageColumn" >
          <mibp-image [userFileId]="$safeNavigationMigration(currentMessage?.imageUserFileId)" [rendition]="rendition.Original" [adjustToContainer]="true" [loaderAspectRatio]="[1,1]" class="center-image"></mibp-image>
        </div>
      }
      <div class="messageColumn" >
        <div class="message-content" [innerHTML]="$safeNavigationMigration(currentMessage?.description)"></div>
      </div>
    </div>

    @if (currentMessage?.disruptionFromDate || currentMessage?.disruptionToDate ) {
      <div>
        <div class="columnFullWidth" >
          <hr class="solid">
          <h1 class="bold" >
            <mibp-datetime [date]="$safeNavigationMigration(currentMessage?.disruptionFromDate)" format="datetime"></mibp-datetime>
            -
            <mibp-datetime [date]="$safeNavigationMigration(currentMessage?.disruptionToDate)" format="datetime"></mibp-datetime>
          </h1>
          <span class="disruptionMsgText"> <mibp-resource-string  key="SystemMessage_DisruptionMessageText"></mibp-resource-string></span>
          <hr class="solid">
        </div>
      </div>
    }
  </div>
</mibp-dialog>
